module.exports = __webpack_public_path__ + "9042cfd8024017c9c7bb13a47e106a95.png";